export const PASSWORD_MINIMUM_LENGTH = 12
export const PASSWORD_MAXIMUM_LENGTH = 50

export const hasValidLength = (password: string): boolean =>
  password.length >= PASSWORD_MINIMUM_LENGTH && password.length <= PASSWORD_MAXIMUM_LENGTH

export const hasOneCapitalLetterMin = (password: string): boolean => /[A-Z]/.test(password)

export const hasOneLowerCaseLetterMin = (password: string): boolean => /[a-z]/.test(password)

export const hasOneNumberMin = (password: string): boolean => /[0-9]/.test(password)

export const hasOneSpecialCharacterMin = (password: string): boolean =>
  /[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]+/.test(password)

export const passwordAllRules = (password: string): boolean =>
  hasValidLength(password) &&
  hasOneCapitalLetterMin(password) &&
  hasOneLowerCaseLetterMin(password) &&
  hasOneNumberMin(password) &&
  hasOneSpecialCharacterMin(password)
